import type { ReactNode } from 'react'
import { cn, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@teach/ui'

interface Props {
  /** Почему контрол погашен; нет причины — подсказки нет. */
  text: string | null
  children: ReactNode
  /** Внутри пункта меню (отступ `px-2`): строка причины встаёт вровень с текстом пункта. */
  inset?: boolean
}

/** Подсказка у погашенного контрола — сразу при наведении на ПК, строкой ниже `lg`. Погашенный пункт меню не ловит
 *  указатель, поэтому подсказку и курсор держит обёртка. */
export const DisabledHint = ({ text, children, inset = false }: Props) => {
  if (text === null) return <>{children}</>
  return (
    <>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              tabIndex={0}
              className="block cursor-not-allowed [&_:disabled]:pointer-events-none"
            >
              {children}
            </span>
          </TooltipTrigger>
          <TooltipContent>{text}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      {/* На таче тултип не открывается: причина — строкой. `<p>` валиден и в `div[role=menu]`. */}
      <p className={cn('mt-1 text-xs text-muted-foreground lg:hidden', inset && 'px-2')}>{text}</p>
    </>
  )
}
